import React from 'react'
import { useEffect, useState, useMemo, useRef, useCallback } from 'react'

import { CCol, CRow, CCard, CCardBody, CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem, CCardTitle, CCardText, CCardImage, CButton, CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem, CFormSelect } from '@coreui/react'
import { CWidgetStatsA, CWidgetStatsD } from '@coreui/react'
import { CChartBar, CChartLine } from '@coreui/react-chartjs'
import Modal from './Modal'
import getAllWorkData from '../../services/general/getAllWorkData.api.js'
import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-enterprise'

import { LicenseManager } from 'ag-grid-enterprise'

LicenseManager.setLicenseKey('For_Trialing_ag-Grid_Only-Not_For_Real_Development_Or_Production_Projects-Valid_Until-21_December_2022_[v2]_MTY3MTU4MDgwMDAwMA==72993978b037cf7071dd20d6c116bd5d')

import 'ag-grid-community/styles//ag-grid.css'
import 'ag-grid-community/styles//ag-theme-material.css'

const ModalTable = (options) => {
  const gridRef = useRef()
  const [title, setTitle] = useState('')

  const onClose = () => {
    setVisible(false)
  }

  const [value, setValue] = useState('')
  const [visible, setVisible] = useState(false)
  const [columns, setColumns] = useState([])
  const defaultColDef = useMemo(() => {
    return {
      enableRowGroup: true,
      enableValue: true,
      sortable: true,
      resizable: true,
      filter: true,
      flex: 1,
      minWidth: 300,
    }
  }, [])
  const [data, setData] = useState([])

  const onBtExport = useCallback(() => {
    gridRef.current.api.exportDataAsExcel()
  }, [])
  const excelStyles = useMemo(() => {
    return [
      {
        id: 'multiline',
        alignment: {
          wrapText: true,
        },
      },
    ]
  }, [])

  useEffect(() => {
    setTitle(options.title)
    setVisible(options.open)
    let c = []
    setValue(options.value)
    let chartData = options.data
    let temp = JSON.parse(chartData.d)['Data']
    for (let j = 0; j < Object.keys(temp[0]).length; j++) {
      if (j == 0) {
        continue
      } else {
        c.push({
          field: Object.keys(temp[0])[j],
          headerName: Object.keys(temp[0])[j],
        })
      }
    }
    setColumns(c)
    setData(temp)
  }, [options])

  return (
    <>
      {visible && (
        <Modal open={visible} type="table" title={value} onClose={onClose}>
          <div
            className="ag-theme-material"
            style={{
              height: '38rem',
            }}
          >
            <button onClick={onBtExport} style={{ margin: '5px 0px', fontWeight: 'bold' }}>
              Export to Excel
            </button>

            <AgGridReact
              rowData={data}
              columnDefs={columns}
              defaultColDef={defaultColDef}
              pagination={true}
              suppressRowClickSelection={true}
              groupSelectsChildren={true}
              rowSelection={'multiple'}
              rowGroupPanelShow={'always'}
              sideBar={'filters'}
              suppressAutoSize={false}
              ref={gridRef}
              excelStyles={excelStyles}
            />
          </div>
        </Modal>
      )}
    </>
  )
}

export default ModalTable
